import { IApiResponse } from 'utils/models';

export type Category = 'transfer' | 'mobilemoney' | 'prepaidcard' | 'billpayments' | 'fxtransferrequest';
export type IHandleFieldsChange = () => void;

export interface IFormValues {
  category: string;
  scheduleId: number | string;
  startDate: string;
  endDate: string;
}

export interface IPaymentType {
  name: string,
  code: string,
}

export interface ITranasactionData {
  id: number,
  name: string,
  bankName?: string,
  billerCode?: string,
  networkCode?: string,
  cardCustomerId?: string,
  accountNumber?: string,
  phoneNumber?: string,
  last4digit?: string,
}

type TransFilterCallback = (benData: ITranasactionData) => boolean;

export interface IFieldData {
  label: string;
  value: string | undefined;
}

export interface ITransactionReportMap {
  key: Category,
  label: string,
  path: string,
  extraQuery?: string,
  filters: IPaymentType[],
  getFilterCb: (filterName: string) => TransFilterCallback,
  getFieldsData: (beneficiary: ITranasactionData, otherBank: boolean) => IFieldData[],
}

export interface ITransactionReportSearchParams {
  reportCategory?: string;
  ScheduleId?: string;
  startDate?: string | null;
  endDate?: string | null;
}

export type MainTabsType = false | 0 | 1 | 2 | 3 | 4;

export type InnerTabsType = false | 0 | 1 | 2 | 3;

export enum TransactionType {
  OWN_TRANSFER ='OWN_ACCOUNT_TRANSFER',
  LOCAL_TRANSFER = 'LOCAL_TRANSFER',
  OTHERBANK_TRANSFER = 'OTHER_BANK_TRANSFER_SINGLE',
  BULK_TRANSFER = 'OTHER_BANK_TRANSFER_BULK',
  MOBILE_MONEY_SINGLE = 'MOBILE_MONEY_SINGLE',
  MOBILE_MONEY_BULK = 'MOBILE_MONEY_BULK',
  PREPAID_CARD_LOAD_SINGLE = 'PREPAID_CARD_LOAD_SINGLE',
  PREPAID_CARD_LOAD_BULK = 'PREPAID_CARD_LOAD_BULK',
  AIRTIME = 'AIRTIME',
  DATA = 'DATA',
  BILLS_PAYMENT = 'BILLS_PAYMENT',
  BILLS_PAYMENT_GHANA_GOV = 'BILLS_PAYMENT_GHANA_GOV',
  BILLS_PAYMENT_SSNIT = 'BILLS_PAYMENT_SSNIT',
  FX = 'FX',
  DIRECT_DEBIT_SINGLE = 'DIRECT_DEBIT_SINGLE',
  DIRECT_DEBIT_BULK = 'DIRECT_DEBIT_BULK',
}

export interface ITransactionReport {
  id: number;
  bulkId: string;
  scheduleId: string;
  sourceAccount: string;
  sourceAccountName: string;
  // SourceAccountType: string;
  beneficiaryName: string;
  beneficiaryAccount: string;
  amount: number;
  narration: string;
  status: string;
  // createdby: string;
  createDate: string;
  transactionType: string;
  transactionDate: string;
  beneficiaryBank: string;
}

export interface ITransactionBulkReport {
  id: number;
  bulkId: string;
  sourceAccount: string;
  sourceAccountName: string;
  charge: number;
  beneficiaryName: string;
  totalCount: number;
  totalAmount: number;
  narration: string;
  status: string;
  // createdby: string;
  createDate: string;
  transactionType: string;
  transactionDate: string;
  beneficiaryBank: string;
}

export interface IApiTransactionReport extends IApiResponse {
  transfers?: ITransactionReport[];
  transactions?: ITransactionBulkReport[];
  pageSize: number;
  pageNumber: number
  count: number
}

export const sortArrays = [
  'Source Account:',
  'Payer Name:',
  'Beneficiary Account:',
  'Beneficiary Name:',
  'Narration:',
  'Amount:',
  'Schedule ID:',
  'Transaction Date:',
  'Beneficiary Bank:',
  'Transaction Type:',
];
